import { defineStore } from 'pinia';
import { useUserStore } from './user';
import { computed, ref } from 'vue';
import { UserRole } from '../types/user';
import router from '../configs/router';
import { authService } from '../services';
import { useClassStore } from './class';
import { RouteName } from '../types/router';

export const useAuthStore = defineStore('auth', () => {
    const accessToken = ref<string | null>(null)
    const refreshToken = ref<string | null>(null)
    const isAuthenticated = computed(() => accessToken.value ? true : false)

    const userStore = useUserStore()
    const classStore = useClassStore()

    async function studentLogin(username: string, password: string): Promise<string | undefined> {
        clearTokens()
        userStore.clearUserInfo()
        classStore.clearClassInfo()

        try {
            const token = await authService.studentLogin(username, password)
            setTokens(token.access_token, token.refresh_token)

            router.push({ name: RouteName.study })
        } catch (error: any) {
            return error.message
        }
    }

    async function teacherLogin(googleToken: string): Promise<string | undefined> {
        clearTokens()
        userStore.clearUserInfo()
        classStore.clearClassInfo()

        try {
            const token = await authService.teacherLogin(googleToken)
            setTokens(token.access_token, token.refresh_token)

            router.push({ name: RouteName.study })
        } catch (error: any) {
            return error.message
        }
    }

    function logout() {
        const currentRole = userStore.userRole
        clearTokens()
        userStore.clearUserInfo()
        classStore.clearClassInfo()

        // Redirect to login page based on user role
        if (currentRole === UserRole.teacher) {
            router.push({ name: RouteName.teacher_login })
            return
        }

        router.push({ name: RouteName.login })
    }

    function setTokens(newAccessToken: string | null, newRefreshToken: string | null) {
        accessToken.value = newAccessToken;
        refreshToken.value = newRefreshToken;
    }

    function clearTokens() {
        accessToken.value = null;
        refreshToken.value = null;
    }

    return {
        accessToken,
        refreshToken,
        isAuthenticated,
        studentLogin,
        teacherLogin,
        logout,
        setTokens,
        clearTokens
    }
}, {
    persist: true
});
